export default {
  // Hook function fires custom logic at a specific moment
  // In this case, inserted is called when a bound element has been inserted into its parent
  inserted: el => {

    // replace data-url with src to load image
    function loadImage() {
      const imageElement = Array.from(el.children).find(
        el => el.nodeName === 'IMG',
      )
      if (imageElement) {
        imageElement.addEventListener('load', () => {
          el.classList.add('loaded')
        })
        imageElement.addEventListener('error', () => console.log('error loading images'))
        imageElement.srcset = imageElement.dataset.set
        imageElement.src = imageElement.dataset.url
      }
    }
    // Interaction Observer API's handleIntersect function
    // Fires when observer detects the element enters the viewport or a parent component
    function handleIntersect(entries, observer) {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          loadImage()
          // prevent image from being loaded again
          observer.unobserve(el)
        }
      })
    }
    function createObserver() {
      const options = {
        root: null,
        threshold: '0'
      }
      const observer = new IntersectionObserver(handleIntersect, options)
      observer.observe(el)
    }

    // Test for browser compatibility
    if (!('IntersectionObserver' in window) || !('IntersectionObserverEntry' in window) || !('intersectionRatio' in window.IntersectionObserverEntry.prototype)) {
      loadImage()
    }
    else {
      createObserver()
    }
  }
}